import { Box, Typography } from '@mui/material';
import { m } from 'framer-motion';
import { useState } from 'react';

interface ExpandableDescriptionProps {
  text: string;
}

export const ExpandableDescription = ({ text }: ExpandableDescriptionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Box
      sx={{
        position: 'relative',
        mb: text.length > 100 ? 1 : 0,
        maxWidth: '100%',
      }}
    >
      <m.div
        initial={false}
        animate={{
          height: isExpanded ? 'auto' : '2.5rem',
        }}
        transition={{ duration: 0.3 }}
        style={{
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box>
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              position: 'relative',
              pr: '10px', // Space for the button
              wordWrap: 'break-word',
              color: '#bdbdbd',
            }}
          >
            {text}
          </Typography>
        </Box>
      </m.div>

      {/* Button always visible outside the motion div */}
      {text.length > 100 && (
        <Typography
          component="span"
          variant="caption"
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            // color: '#FFD700',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            backgroundColor: '#000',
            p: 0.1,
            px: 1,
            borderRadius: 0.3,
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          {isExpanded ? 'Show Less' : 'Show More'}
        </Typography>
      )}
    </Box>
  );
};
